var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPublishNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97387 0.824092C8.94561 1.40293 8.57905 3.07611 5.81663 5.83853L5.6309 7.51002L3.95941 9.18151L4.14514 7.51002L2.28794 5.65282L0.616455 5.83853L2.28794 4.16707L3.95941 3.98133C6.72183 1.21892 8.30218 0.759494 8.97387 0.824092ZM1.82364 7.97432L2.47365 6.20998L3.58799 7.32431L1.82364 7.97432ZM7.48812 2.30985L7.05983 2.0529L6.37849 2.53555L6.93094 2.86702L7.25017 3.39906L7.72424 2.70342L7.48812 2.30985Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublishNew);
export default __webpack_public_path__ + "static/media/icon-publish-new.53f4b4e805fd76ec1a733125567c6344.svg";
export { ForwardRef as ReactComponent };